"use client"

import type React from "react"
import * as translator from "../../utils/translator";

interface ShippingProgressBarV25Props {
  currentAmount: number
  freeShippingThreshold: number
  currency?: string
  language?: string
}

const ShippingProgressBarV25: React.FC<ShippingProgressBarV25Props> = ({
  currentAmount,
  freeShippingThreshold,
  currency = "€",
  language = "de",
}) => {
  if (freeShippingThreshold == null) return null

  const isAlwaysFree = freeShippingThreshold <= 0;
  const remainingAmount    = isAlwaysFree ? 0   : Math.max(0, freeShippingThreshold - currentAmount)
  const progressPercentage = isAlwaysFree ? 100 : Math.min(100, (currentAmount / freeShippingThreshold) * 100)
  const isEligibleForFreeShipping = remainingAmount <= 0

  const formatAmount = (amount: number) => {
    return amount.toFixed(2).replace(".", ",")
  }

  const getRemainingText = () => {
    const only = translator.translate(language, "shipping", "otcCartSlider/only")
    const leftForFreeShipping = translator.translate(language, "shipping", "otcCartSlider/left_for_free_shipping")
    const formattedAmount = `${formatAmount(remainingAmount)}\u00A0${currency}`

    return { only, formattedAmount, leftForFreeShipping }
  }

  const getFreeShippingText = () => {
    const freeShippingText = translator.translate(language, "shipping", "otcCartSlider/free_shipping")
    return `🎉 ${freeShippingText}`
  }

  const remainingTextData = getRemainingText()

  return (
    <div className="border border-solid border-[#e5e7eb] rounded-[15px] px-[16px] py-[12px]">
      <div className="flex flex-col gap-[12px]">
        {isEligibleForFreeShipping ? (
          <p className="font-poppins text-[14px] text-green-600 font-semibold leading-[20px]">
            <span>{getFreeShippingText()}</span>
          </p>
        ) : (
          <p className="font-poppins text-[14px] text-[#1a1a2e] leading-[20px]">
            {remainingTextData.only}{" "}
            <span className="font-semibold">{remainingTextData.formattedAmount}</span>{" "}
            {remainingTextData.leftForFreeShipping}
          </p>
        )}

        <div className="w-full h-[8px] bg-[#f1f1f1] rounded-full overflow-hidden">
          <div
            className="h-[8px] rounded-full transition-all duration-300 ease-out"
            style={{
              width: `${progressPercentage}%`,
              backgroundImage: "linear-gradient(90deg, rgba(21, 150, 124, 1) 0%, rgba(114, 179, 62, 1) 100%)",
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ShippingProgressBarV25
